module.exports = Object.freeze({
  CANVAS_DEFAULT_WIDTH: 1920,
  CANVAS_DEFAULT_HEIGHT: 1080,
  CANVAS_DEFAULT_BACKGROUND_COLOR: 'rgba(0, 0, 0, 0.6)',
  CANVAS_PHOTO_PADDING: 1920 * 0.07,
  CANVAS_PHOTO_DEFAULT_Y: 100,
  CANVAS_DEFAULT_FONT: 'Arial',
  CANVAS_DEFAULT_FONT_SIZE: '80',
  CANVAS_DEFAULT_TEXT_ALIGN: 'center',
  CANVAS_DEFAULT_LINE_HEIGHT: 100,
  CANVAS_DEFAULT_TEXT_COLOR: '#FFFFFF',
  SCALE_FACTOR: 48,
  COMPATIBILITY_X_FACTOR: 105,
  COMPATIBILITY_Y_FACTOR: 50,
});